module.exports = __webpack_public_path__ + "resources/img/img_maxgauge2.9fb1982cc2ef4e6bfa174baf4d105d5c.png";